import React from 'react';
import { Calculator } from 'lucide-react';
import { Link } from 'react-router-dom';

const Logo: React.FC = () => {
  return (
    <Link 
      to="/" 
      className="flex items-center space-x-2 text-emerald-700 hover:text-emerald-800 transition-colors"
      aria-label="Kalculas - Home"
    >
      <Calculator className="h-8 w-8" aria-hidden="true" />
      <span className="text-2xl font-bold">Kalculas</span>
    </Link>
  );
};

export default Logo;